<template>
  <div class="horse-list">
		<table>
			<thead>
				<tr>
					<th>
						<div class="bar bg-blue">
							<h3>Age</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Colour</h3>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(age, i) in ages" :key="i">
					<td class="name">{{ age.text }}</td>
					<td v-bind:style="{ background: age.colour }" class="colour"></td>
					<td class="icon edit">
						<button class="button-transparent" @click="$emit('edit', age)">
							<i class="ss-write ss-glyphish-filled"></i>
						</button>
					</td>
				</tr>
				<tr v-if="ages.length === 0">
					<td colspan="6">No ages found</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: ['ages'],
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Age/List.vue